import React from 'react'

function ThemeContent({children}) {
  return (
    <div className="main-content container-fluid">
      {children}
    </div>
  )
}

export default ThemeContent